export const IDEMPOTENCY_HEADER = 'Idempotency-Key';

export const IDEMPOTENCY_STORAGE_KEY = 'flexibilitypay-idempotency-storage';

export const IDEMPOTENCY_TTL_MS = 30 * 60 * 1000;

export const IDEMPOTENCY_METHODS: ReadonlyArray<string> = ['POST', 'PATCH', 'PUT', 'DELETE'];
